import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import Index from "../pages/Index.vue";

export default new Route("notifications", "/notifications", RouterView, [
	new Route("notifications.index", "", Index, []),
]);
